import EntityPresenter, { bindPresenterMethods } from './entityPresenter'

export default class SettingsPresenter extends EntityPresenter {
  static urn = 'settings'
  static key = 'setting'

  static navOptions(key = 'settings') {
    const routes = {
      settings: {
        icon: 'settings',
        pageRoutes: ['settings'],
      },
    }
    return routes[key]
  }
}

bindPresenterMethods(SettingsPresenter)
